export default "__VITE_ASSET__b38bbd3b__"